// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-k_gV","advertDetailHeaderLocation__value":"c-k_gW"};